import React from 'react';
import image1 from '../assets/Blog1.png';
import image2 from '../assets/Blog2.png';
import image3 from '../assets/Blog3.png';
import image4 from '../assets/Blog4.png';
import image5 from '../assets/Blog5.png';
import image6 from '../assets/Blog6.png';
const posts = [
  {
    title: 'Top 5 Scenic Road Trips from Chennai to Coastal Getaways',
    date: 'September 22, 2023',
    author: 'Admin',
    excerpt: 'Chennai, with its vibrant city life and rich culture, is the gateway to some of South India\'s most beautiful...',
    image: image1,
  },
  {
    title: 'How to Plan a Road Trip from Bangalore to Ooty: Route and Tips',
    date: 'September 17, 2023',
    author: 'Admin',
    excerpt: 'A road trip from Bangalore to Ooty is a refreshing getaway for anyone looking to escape the hustle and...',
    image: image2,
  },
  {
    title: 'Solo Women Travel: Safe and Scenic Routes in South India',
    date: 'September 25, 2023',
    author: 'Admin',
    excerpt: 'Traveling solo can be transformative and empowering, especially for women. South India, with its cultural heritage, diverse...',
    image: image3,
  },
  {
    title: 'Tips for Renting a Bike During Monsoon: Stay Safe on the Road',
    date: 'September 15, 2023',
    author: 'Admin',
    excerpt: 'Monsoon brings a refreshing change, making the world seem greener and more vibrant. However, they also present...',
    image: image4,
  },
  {
    title: 'Best Scenic Road Routes in Karnataka',
    date: 'September 29, 2023',
    author: 'Admin',
    excerpt: 'Explore the best scenic routes in Karnataka, perfect for road trips and adventure...',
    image: image5,
  },
  {
    title: 'The Benefits of Choosing a Self-Drive Car for Road Trips',
    date: 'October 1, 2023',
    author: 'Admin',
    excerpt: 'Self-drive cars offer flexibility and freedom, making them a great option for road trips...',
    image: image6,
  },
  {
    title: 'Best Scenic Road Routes in Karnataka',
    date: 'September 29, 2023',
    author: 'Admin',
    excerpt: 'Explore the best scenic routes in Karnataka, perfect for road trips and adventure...',
    image: image5,
  },
  {
    title: 'Best Scenic Road Routes in Karnataka',
    date: 'September 29, 2023',
    author: 'Admin',
    excerpt: 'Explore the best scenic routes in Karnataka, perfect for road trips and adventure...',
    image: image5,
  },
  {
    title: 'Best Scenic Road Routes in Karnataka',
    date: 'September 29, 2023',
    author: 'Admin',
    excerpt: 'Explore the best scenic routes in Karnataka, perfect for road trips and adventure...',
    image: image5,
  },
  {
    title: 'Best Scenic Road Routes in Karnataka',
    date: 'September 29, 2023',
    author: 'Admin',
    excerpt: 'Explore the best scenic routes in Karnataka, perfect for road trips and adventure...',
    image: image5,
  },
  
];

function Category() {
  return (
    <div className="container mx-auto w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
        {posts.map((post, index) => (
          <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
            <img src={post.image} alt={post.title} className="w-full h-auto object-cover" />
            <div className="p-4">
              <h2 className="text-2xl text-left font-semibold text-gray-800">{post.title}</h2>
              <p className="text-sm mt-2 text-gray-500 text-left">By {post.author} | {post.date}</p>
              <p className="text-gray-700 mt-2 text-left">{post.excerpt}</p>
              {/* <a href="#" className="text-[#FF9630] hover:underline mt-4 inline-flex">Read More &rarr;</a> */}
              <a href="#" className="text-[#FF9630] hover:underline mt-4 inline-flex text-left">Read More &rarr;</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Category;


// when i click on the particular blog on click i want  diaplay the same  single imge 
//  with full width and below some content i want 